import axios from 'axios';
import { attachAuthRefresh } from '../../lib/authRefresh';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = attachAuthRefresh(axios.create({ baseURL: API, withCredentials: true }));

export const taApi = {
  config: () => http.get('/technique-assessments/config').then((r) => r.data),
  quote: (body) => http.post('/technique-assessments/quote', body).then((r) => r.data),
  checkout: (body) => http.post('/technique-assessments/checkout', body).then((r) => r.data),
  get: (id, token) => http.get(`/technique-assessments/${id}`, { params: token ? { token } : {} }).then((r) => r.data),
  upgrade: (id, token) => http.post(`/technique-assessments/${id}/upgrade`, null, { params: token ? { token } : {} }).then((r) => r.data),
  mine: () => http.get('/me/technique-assessments').then((r) => r.data),
  pdfUrl: (id, token) => `${API}/technique-assessments/${id}/pdf${token ? `?token=${encodeURIComponent(token)}` : ''}`,
  admin: {
    summary: () => http.get('/admin/technique-assessments/summary').then((r) => r.data),
    list: (params) => http.get('/admin/technique-assessments', { params }).then((r) => r.data),
    detail: (id) => http.get(`/admin/technique-assessments/${id}`).then((r) => r.data),
    assign: (id, coach_id) => http.post(`/admin/technique-assessments/${id}/assign`, { coach_id }).then((r) => r.data),
    status: (id, status, note) => http.post(`/admin/technique-assessments/${id}/status`, { status, note }).then((r) => r.data),
    customer: (id, body) => http.patch(`/admin/technique-assessments/${id}/customer`, body).then((r) => r.data),
    note: (id, text) => http.post(`/admin/technique-assessments/${id}/notes`, { text }).then((r) => r.data),
    waTemplate: (id) => http.get(`/admin/technique-assessments/${id}/whatsapp-report/template`).then((r) => r.data.text),
    waSave: (id, text) => http.put(`/admin/technique-assessments/${id}/whatsapp-report`, { text }).then((r) => r.data),
    waApprove: (id) => http.post(`/admin/technique-assessments/${id}/whatsapp-report/approve`).then((r) => r.data),
    waDelivered: (id) => http.post(`/admin/technique-assessments/${id}/whatsapp-report/delivered`).then((r) => r.data),
    pdfUpload: (id, file, onProgress) => {
      const fd = new FormData();
      fd.append('file', file);
      return http.post(`/admin/technique-assessments/${id}/pdf`, fd, { onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0) }).then((r) => r.data);
    },
    pdfUrl: (id) => `${API}/admin/technique-assessments/${id}/pdf`,
    pdfDelete: (id) => http.delete(`/admin/technique-assessments/${id}/pdf`).then((r) => r.data),
    pdfApprove: (id) => http.post(`/admin/technique-assessments/${id}/pdf/approve`).then((r) => r.data),
    pdfDelivered: (id) => http.post(`/admin/technique-assessments/${id}/pdf/delivered`).then((r) => r.data),
    settings: () => http.get('/admin/technique-assessments/settings').then((r) => r.data),
    saveSettings: (body) => http.put('/admin/technique-assessments/settings', body).then((r) => r.data),
    export: async () => {
      const r = await http.get('/admin/technique-assessments/export.xlsx', { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = 'lgra-technique-assessments.xlsx'; a.click();
      URL.revokeObjectURL(url);
    },
  },
};

export const errMsg = (e, fb = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  return (typeof d === 'string' ? d : d?.message) || e?.message || fb;
};
export const RM = (cents) => `RM ${(Number(cents || 0) / 100).toFixed(2)}`;
export const RM0 = (cents) => `RM${Math.round(Number(cents || 0) / 100)}`;

export const STATUS_TONE = {
  pending_payment: 'bg-slate-100 text-slate-700', payment_verification: 'bg-amber-100 text-amber-800',
  paid_pending_review: 'bg-sky-100 text-sky-800', assigned: 'bg-indigo-100 text-indigo-800',
  under_assessment: 'bg-violet-100 text-violet-800', report_ready: 'bg-emerald-100 text-emerald-800',
  completed: 'bg-emerald-600 text-white', resubmission_required: 'bg-rose-100 text-rose-800',
};
